var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8716 4.66516L6.8701 11.6667H6.87154V23.3334H9V16.0001V15.0001H10H15H16V16.0001V23.3334H20.8715V11.6667H20.8732L13.8716 4.66516ZM14 23.3334V17.0001H11V23.3334H14ZM2.81536 15.7214L4.53821 13.9986V23.3334C4.53821 24.622 5.58288 25.6667 6.87154 25.6667H20.8715C22.1602 25.6667 23.2049 24.622 23.2049 23.3334V13.9984L24.9279 15.7214L26.5766 14.0727L15.5201 3.01621C14.6097 2.10576 13.1336 2.10576 12.2231 3.01621L1.16663 14.0727L2.81536 15.7214Z",
    fill: "#6D927C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeActive);
export default __webpack_public_path__ + "static/media/home_active.330888a439cb36826ae6c6f8c8a09299.svg";
export { ForwardRef as ReactComponent };